import "./JSONformatter.css";
import ToolHeader from "../../Components/ToolHeader";
import { Row, Col, Button } from "react-bootstrap";
import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { ValidateJSON } from "../../Services/APIService";

import FormatterPanel from "../../HomePage/FormatterPanel";
import { ExampleJSON } from "../../Services/Tools";
import { InputHeaderButtons } from "./JSONToolsHeaderButtons";


function JSONValidator() {
  const { collapsed } = useOutletContext() || {};
  const [text, setText] = useState("");
  const [result, setResult] = useState("");
  const indent = 2;
  const [isValid, setIsValid] = useState(true);
  const [recentInput, setRecentInput] = useState("");
  const toolFav = { toolName: 'JSON Validator', Iconpath: "/Bracketsblue.svg" };

  

  

  const lineCount = text !== "" ? (typeof text === "string" ? text : "").split("\n").length : 0;
  const resultLineCount = result !== "" ? (typeof result === "string" ? result : "").split("\n").length : 0;

  const validate = async () => {
    if (text.trim() === "") {
      setResult("Please enter JSON data to validate.");
      setIsValid(false);
      return;
    }
    if (text === recentInput) {
      alert("No changes detected in the input JSON.");
      return;
    }
    else {
      setRecentInput(text);
    }
    try {
      const response = await ValidateJSON({ input: text });
      if (response.data.valid === false) {
        setResult(`Invalid JSON input.\nError is in line number ${response.data.line} colum ${response.data.column} \n${response.data.error}`);
        setIsValid(response.data.valid);
      }
      else {
        setResult(response.data.message);
        setIsValid(response.data.valid);
      }

      console.log("response", response.data)
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const pasteExample = () => {
    const exampleText = typeof ExampleJSON === "string" ? ExampleJSON : JSON.stringify(ExampleJSON, null, indent);
    setText(exampleText);
  };

  return (
    <>
      <Col>
        <ToolHeader title="JSON Validator" description="Validate JSON syntax and inspect structure" toolFav={toolFav} />

        <Row className="ActionButtons">
          <Col>
            <Button className="ActionButton">RFC 8259
              <span className="active-dot" />
            </Button>
          </Col>
        </Row>

        <Row className="Formatter  json-formatter-row">
          <Col xs={12} lg={6} className="json-formatter-column">
            <FormatterPanel
              title="Input JSON"
              value={text}
              onChange={(e) => setText(e.target.value)}
              placeholder="Paste valid JSON to see structure analysis..."
              lineCount={lineCount}
              collapsed={collapsed}
              editorContainerStyle={{ overflow: "auto" }}
              wrap={false}
              headerButtons={
                <InputHeaderButtons
                  primaryLabel="Example"
                  onPrimary={pasteExample}
                  onClear={() => {
                    setText("");
                    setResult("");
                  }}
                  onImport={(fileContent) => setText(fileContent)}
                  accept=".json"
                  showExecute={true}
                  onExecute={validate}
                  executeLabel="Validate"
                />
              }
              footerLeft={`Characters : ${text.replaceAll(" ", "").length}`}
              footerRight={`Size : ${new Blob([text]).size} B`}

            />
          </Col>
            <Col xs={12} lg={6} className={`json-formatter-column ${isValid ? "valid-json" : "invalid-json"}`}>
              <FormatterPanel
                title="Structure Analysis"
                value={result ?? ""}
                placeholder="Validation result will appear here..."
                lineCount={resultLineCount}
                editorContainerStyle={{ overflow: "auto" }}
                wrap={false}
                readOnly
                footerLeft={`Characters : ${result.replaceAll(" ", "").length}`}
                footerRight={`Size : ${new Blob([result ?? ""]).size} B`}
              />
          </Col>
        </Row>
      </Col>
    </>
  );
}

export default JSONValidator;


